module.exports = __webpack_public_path__ + "img/cfee.816ff4fa.png";